module.exports = __webpack_public_path__ + "5896f0115602ee17eba5c44f4f1d9442.png";